// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"f4356c47","787":"f35f70c9"}[chunkId] + ".chunk.js";
};